
export class Entity {
  entityId: string;
  offScene? = false;

  currentTraslation = {
    x : 0.0,
    y : 0.0,
    z : 0.0
  }

  constructor(entityId) {
    this.entityId = entityId;
  }

  setOffScene(canvas, value) {
    this.offScene = value;
    this.currentTraslation.x += value ? 1000 : -1000;
    canvas.translateEntity(this.entityId, this.currentTraslation.x, this.currentTraslation.y, this.currentTraslation.z);
  }

  translate(canvas, x, y, z) {
    if (!isNaN(x) && !isNaN(y) && !isNaN(z)) {
      canvas.translateEntity(this.entityId, x, y, z);
      this.currentTraslation.x += x;
      this.currentTraslation.y += y;
      this.currentTraslation.x += z;
    }
  }

  reset(canvas) {
    this.translate(canvas, -this.currentTraslation.x, -this.currentTraslation.y, -this.currentTraslation.z);
    this.offScene = false;
  }

  translateCamera(world, x, y) {
    if (!isNaN(x) && !isNaN(y)) {
      world.translateCameraOrbitView(x, y, 1);
      world.updateCameraOrbitView();
      this.currentTraslation.x += x;
      this.currentTraslation.y += y;
    }
  }

  resetCamera(world) {
    this.translateCamera(world, -this.currentTraslation.x, -this.currentTraslation.y);
  }

}

export class EntityTraslation {

  entityId: string;
  x: number = 0.0;
  y: number = 0.0;
  z: number = 0.0;
  rotation? = {
    x: 0,
    y: 0,
    z: 0
  }
  start?: number;
  end?: number;
  animazioneInCorso?: boolean
}

export class CameraTraslation {
  x?: number = 0.0;
  y?: number = 0.0;
  z?: number = 0.0;
  offScene? = false;
  start: number;
  end: number;
  animazioneInCorso?: boolean;
}

export namespace Costants {


  export const entities: Entity[] = [
    new Entity('bilanciere_1'),
    new Entity('bilanciere_2'),
    new Entity('timbro_1'),
    new Entity('timbro_2'),
    new Entity('molla_1'),
    new Entity('molla_2'),
    new Entity('base'),
    new Entity('biella_2'),
    new Entity('ruota_2'),
    new Entity('ruota_1'),

    new Entity('camera'),
  ]
  
  export const mainAnimationEntityTraslations: EntityTraslation[] = [

    {entityId: 'bilanciere_1',  x: 2,     y: 0,     z: 0,     start: 2,     end: 4},
    {entityId: 'bilanciere_2',  x: -2,    y: 0,     z: 0,     start: 2,     end: 4},

    {entityId: 'timbro_1',      x: 0,     y: 2,     z: 0,     start: 6,     end: 8},
    {entityId: 'timbro_2',      x: 0,     y: 2,     z: 0,     start: 6,     end: 8},

    {entityId: 'molla_1',       x: 0,     y: 4,     z: 0,     start: 8,     end: 10,    rotation : { x: 0, y: 0, z: 720 },},
    {entityId: 'molla_2',       x: 0,     y: 4,     z: 0,     start: 8,     end: 10,    rotation : { x: 0, y: 0, z: 720 },},

    {entityId: 'base',          x: 0,     y: -4,    z: 0,     start: 12,     end: 14},

    {entityId: 'biella_2',      x: 0,     y: -8.5,  z: 0,     start: 16,     end: 18},

    {entityId: 'ruota_2',       x: -2.5,  y: 0,     z: 0,     start: 20,     end: 22,   rotation : { x: 180, y: 0, z: 0 },},

    {entityId: 'ruota_1',       x: -5,    y: 0,     z: 0,     start: 22,     end: 24,   rotation : { x: 180, y: 0, z: 0 },},
    
  ]

  export const cameraTraslations: CameraTraslation[] = [

    {  x: -35,     y: 25,     z: 0,     start: 0,     end: 2},

    {  x: -15,     y: 0,      z: 0,     start: 4,     end: 6},

    {  x: 0,       y: -20,    z: 0,     start: 10,     end: 12},
    
    {  x: 50,      y: -20,    z: 0,     start: 14,     end: 16},

    {  x: -25,     y: 20,     z: 0,     start: 18,     end: 20},

    {  x: 25,      y: 5,     z: 0,     start: 24,     end: 26},

  ]

  export const steps = [
   
    { /* Step1 */
      start: [
        {entityId: 'bilanciere_1',  x: 2,       y: 0,     z: 0,   },
        {entityId: 'bilanciere_2',  x: -2,      y: 0,     z: 0,   },
        {entityId: 'timbro_1',      offScene: true   },
        {entityId: 'timbro_2',      offScene: true   },
        {entityId: 'molla_1',       offScene: true   },
        {entityId: 'molla_2',       offScene: true   },
        {entityId: 'base',          offScene: true   },
        {entityId: 'biella_2',      offScene: true   },
        {entityId: 'ruota_2',       offScene: true   },
        {entityId: 'ruota_1',       offScene: true   },
      ],
      translate: [
        {entityId: 'bilanciere_1',  x: 2,     y: 0,     z: 0,     start: 1,     end: 3},
        {entityId: 'bilanciere_2',  x: -2,    y: 0,     z: 0,     start: 1,     end: 3},
      ]
    },
    { /* Step2 */
      start: [
        {entityId: 'timbro_1',      x: 0,   y: 2,     z: 0,   },
        {entityId: 'timbro_2',      x: 0,   y: 2,     z: 0,   },
        {entityId: 'molla_1',       offScene: true   },
        {entityId: 'molla_2',       offScene: true   },
        {entityId: 'base',          offScene: true   },
        {entityId: 'biella_2',      offScene: true   },
        {entityId: 'ruota_2',       offScene: true   },
        {entityId: 'ruota_1',       offScene: true   },
      ],
      translate: [
        {entityId: 'timbro_1',      x: 0,     y: 2,     z: 0,     start: 1,     end: 3},
        {entityId: 'timbro_2',      x: 0,     y: 2,     z: 0,     start: 1,     end: 3},
      ]
    },
    { /* Step3 */
      start: [
        {entityId: 'molla_1',       x: 0,   y: 4,     z: 0,   },
        {entityId: 'molla_2',       x: 0,   y: 4,     z: 0,   },
        {entityId: 'base',          offScene: true   },
        {entityId: 'biella_2',      offScene: true   },
        {entityId: 'ruota_2',       offScene: true   },
        {entityId: 'ruota_1',       offScene: true   },
      ],
      translate: [
        {entityId: 'molla_1',       x: 0,     y: 4,     z: 0,     rotation : { x: 0, y: 0, z: 720 },  start: 1,     end: 3,},
        {entityId: 'molla_2',       x: 0,     y: 4,     z: 0,     rotation : { x: 0, y: 0, z: 720 },  start: 1,     end: 3},
      ]
    },
    { /* Step4 */
      start: [
        {entityId: 'base',          x: 0,       y: -4,    z: 0,   },
        {entityId: 'biella_2',      offScene: true   },
        {entityId: 'ruota_2',       offScene: true   },
        {entityId: 'ruota_1',       offScene: true   },
      ],
      translate: [
        {entityId: 'base',          x: 0,     y: -4,    z: 0,     start: 1,     end: 3},
      ]
    },
    { /* Step5 */
      start: [
        {entityId: 'biella_2',      x: 0,       y: -8.5,  z: 0,   },
        {entityId: 'ruota_2',       offScene: true   },
        {entityId: 'ruota_1',       offScene: true   },
      ],
      translate: [
        {entityId: 'biella_2',      x: 0,     y: -8.5,  z: 0,   start: 1,     end: 3},
      ]
    },
    { /* Step6 */
      start: [
        {entityId: 'ruota_2',       x: -2.5,  y: 0,     z: 0,  },
        {entityId: 'ruota_1',       offScene: true   },
      ],
      translate: [
        {entityId: 'ruota_2',       x: -2.5,  y: 0,     z: 0,     rotation : { x: 180, y: 0, z: 0 },    start: 1,   end: 3},
      ]
    },
    { /* Step7 */
      start: [
        {entityId: 'ruota_1',       x: -5,    y: 0,     z: 0,  },
      ],
      translate: [
        {entityId: 'ruota_1',       x: -5,    y: 0,     z: 0,     rotation : { x: 180, y: 0, z: 0 },    start: 1,     end: 3},
      ]
    }
  ]

}
